export default __webpack_public_path__ + "static/media/workouttimes_3.3fcad95e.jpg";